module.exports = __webpack_public_path__ + "img/MINI_LOGO_CZARNE.acda65bf.png";